export const DEFAULT_IPDB_TITLE_SIZE = 15;
export const DEFAULT_IPDB_LABELS_SIZE = 14;
